"use client";
import React, { useState } from "react";
import Image from "next/image";
// import { blogData } from "@/data/blogData";
import { IHeroImage, IHeroRecord } from "@/app/package/interface/IHeroSection";

interface BlogHeroProps {
  blogHero?: IHeroRecord[];
}

const BlogHero: React.FC<BlogHeroProps> = ({ blogHero }) => {
  const [active, setActive] = useState(0);
  const hero = blogHero?.[0];
  const slides = hero?.image ?? [{ id: "fallback", image: "/placeholder.png" }];

  return (
    <figure className="relative h-[62vh] w-full overflow-hidden">
      {slides.map((slide: IHeroImage, idx: number) => (
        <Image
          key={idx}
          src={slide?.image || "/placeholder.png"}
          alt={`slide-${idx}`}
          fill
          className={`object-cover filter brightness-75 transition-opacity duration-500 ${
            idx === active ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        />
      ))}

      {/* <figcaption>
        <div className="absolute left-10 bottom-20 text-white max-w-lg">
          <h1 className="typography-h1-bold mb-4">{blogHero[0]?.title}</h1>
          <p className="typography-mid-body-regular">{blogHero[0]?.subtitle}</p>
        </div>
      </figcaption> */}
      <figcaption className="absolute left-[40%] bottom-20 text-white max-w-lg typography-h1-regular font-bold mb-4">
        {hero?.title || "Blog"}{" "}
      </figcaption>

      {/* Carousel Dots */}
      {slides.length > 1 && (
        <div className="absolute left-[7%] bottom-[13%] transform -translate-x-1/2 flex gap-2">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`w-3 h-3 rounded-full transition-colors ${
                i === active ? "bg-white" : "bg-white/30"
              }`}
            />
          ))}
        </div>
      )}
    </figure>
  );
};

export default BlogHero;
